// @ts-nocheck

import React, { useRef, useLayoutEffect, useState } from 'react';
import type { Node } from 'react';
import styled from 'styled-components';

import { useViewportContext } from '../../../contexts/ViewportContext';

const Flex = styled.div`
  height: ${({ $isDisabled, $barsHeight }) => ($isDisabled ? 'auto' : `calc(100vh - ${$barsHeight}px)`)};
`;

type Props = {
  children: Node;
  className?: string;
  handleTopOffset?: boolean;
  isDisabled?: boolean;
};

const FitHeight = ({ className, children, handleTopOffset = true, isDisabled = false }: Props) => {
  const ref = useRef(null);
  const { height, navbarHeight, tabbarHeight } = useViewportContext();
  const [offsetTop, setOffsetTop] = useState(navbarHeight + tabbarHeight);

  useLayoutEffect(() => {
    if (handleTopOffset && ref.current) {
      const { height: refHeight } = ref.current.getBoundingClientRect();
      setOffsetTop(navbarHeight + tabbarHeight + (height - refHeight));
    }
  }, [handleTopOffset, navbarHeight, ref, tabbarHeight, height]);

  return (
    <Flex className={className} $barsHeight={offsetTop} $isDisabled={isDisabled} ref={ref}>
      {children}
    </Flex>
  );
};

export default FitHeight;
